import { useEffect, useState } from 'react'
import './keypad.css'

export function PopupForm({getValue, setValue, setClosed, setCancel=setClosed, title="Form", children}) {

    function UpdateFromChildren(event) {
        const newVal = {...getValue};
        newVal[event.target.name] = event.target.value;
        setValue(newVal)
    }

    return (<>
        <div className='center-blur-bg'>
            <div style={{display: "flex"}}>

                <form id="popup_form_internal" className='keypad_child_panel' style={{minWidth: "15vw"}} onInputCapture={UpdateFromChildren}> 
                    <h1> {title} </h1>
                    {children} 
                </form>

                <div className='v-stack' style={{height: "100%"}}>
                    <button className='form_popup_cancel' onClick={setCancel}> X </button> {/* style is in keypad.css */ }
                    <br style={{flexGrow: 1}}/>
                    <button className='keypad_submit' onClick={setClosed}> ➔ </button>
                </div>

            </div>
        </div>
    </>)
}